import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AgoraConfigService } from 'src/AgoraConfigService';

@Component({
  selector: 'app-advance-search',
  templateUrl: './advance-search.component.html',
  styleUrls: ['./advance-search.component.css']
})
export class AdvanceSearchComponent implements OnInit {

  agoraConfigObject: any;
  adcDashboardUrl:any;

  constructor(private sanitizer: DomSanitizer, private agoraConfig: AgoraConfigService) { 
		this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;

    // const url = 'http://192.168.193.65:8080/adc-dashboard-app/browser/';
        // const url = 'http://192.168.194.248:9095/adc-dashboard-app/browser/';
     const url = `${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.advanceSearchUrl}`;

      this.adcDashboardUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit(): void {
  }
   // Handle iframe load event
   onIframeLoad(): void {
 
    // You can add additional logic here when the iframe finishes loading
  }

}
